import { dynamicSort } from '../../../../common/utilities/sort';
import _ from 'lodash';
export const handleSort = (filteredData, setFilteredData, dataKey, sortType) => {
    let sortedFilteredData = [];
    const dynamicSortOrder = sortType === 'desc' ? '-' : '';

    switch (dataKey) {
        case 'name':
            sortedFilteredData = filteredData.sort(
                dynamicSort(`${dynamicSortOrder}name`),
            );
            break;
        case 'description':
            sortedFilteredData = filteredData.sort(
                dynamicSort(`${dynamicSortOrder}description`),
            );
            break;
        case 'duration':
            sortedFilteredData = filteredData.sort(
                dynamicSort(`${dynamicSortOrder}periodLength`),
            );
            break;
        case 'effectiveDate':
            sortedFilteredData = filteredData.sort(
                dynamicSort(`${dynamicSortOrder}displayEffectiveDate`),
            );
            break;
        case 'endDate':
            sortedFilteredData = filteredData.sort(
                dynamicSort(`${dynamicSortOrder}displayEndDate`),
            );
            break;
        default:
            break;
    }
    setFilteredData(_.cloneDeep(sortedFilteredData));
};

const textFitsInContainerElement = (text, containerElement) => {
    if (!containerElement) {
        return false;
    }

    const font = window.getComputedStyle(containerElement, null).getPropertyValue('font');
    const canvasContext = document.createElement("canvas").getContext("2d");
    canvasContext.font = font;
    const textWidth = canvasContext.measureText(text).width;
    const containerWidth = containerElement.clientWidth;
    return textWidth < containerWidth;
}

export const genOrgPath = (orgPath, containerElement) => {
    let orgPathSplit = orgPath.split('/');
    let orgPathShort = orgPath;
    if (orgPathSplit.length > 4) {
        let auxIterator = 0;
        orgPathShort = '';
        for (let i = orgPathSplit.length - 1; i >= 0 && auxIterator < 4; i--) {
            const newOrgPathShort = `/${orgPathSplit[i]}${orgPathShort}`;
            if (!textFitsInContainerElement(`...${newOrgPathShort}`, containerElement)) {
                break;
            }
            orgPathShort = newOrgPathShort;
            auxIterator++;
        }
        orgPathShort = orgPathSplit.length > auxIterator ? `...${orgPathShort}` : orgPathShort;
    }
    return orgPathShort;
};